import { generateId } from '@/utils/create'

export function getRangeItem () {
  return {
    id: generateId(),
    from: '',
    to: ''
  }
}
